import axios from "axios";
import { t, getLang } from "../i18n";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
const TOKEN_KEY = "circulo_token";

let unlockToken = null;
const listeners = { onPinRequired: null, onUnauthorized: null };

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => (t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY));
export const getUnlockToken = () => unlockToken;
export const setUnlockToken = (t) => (unlockToken = t);
export const setAuthListeners = (l) => Object.assign(listeners, l);

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  if (unlockToken) config.headers["X-Unlock-Token"] = unlockToken;
  config.headers["Accept-Language"] = getLang();
  return config;
});

api.interceptors.response.use(
  (res) => {
    const fresh = res.headers?.["x-unlock-token"];
    if (fresh) unlockToken = fresh;
    return res;
  },
  (err) => {
    const status = err.response?.status;
    const url = err.config?.url || "";
    const authFlow = url.startsWith("/auth/") || url.startsWith("/pin/") || url.startsWith("/webauthn/");
    if (status === 401 && !authFlow) listeners.onUnauthorized?.();
    if (status === 403 && /Requiere PIN|PIN required|PIN requis|PIN erforderlich/.test(err.response?.data?.detail || "")) listeners.onPinRequired?.();
    return Promise.reject(err);
  }
);

export function errorMessage(err, fallback = t("common.error")) {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (d.retry_after_seconds != null) return t("common.retryIn", { msg: d.mensaje, s: d.retry_after_seconds });
  return d.mensaje || d.msg || String(d);
}
